window.footer = {
    init: function () {
        this.initMobileNavigation();
    },

    /**
     * Initialize Mobile Navigation if Mobile View
     */
    initMobileNavigation: function () {
        if(window.innerWidth < 768) {
            window.footerNavigation.initMobileNav();
        }
    },
};
